import React, { useRef } from "react";
import PlayerInfoIcon from "../../../assets/icons/svg/PlayerInfoIcon";
import ProgramDetail from "../../programDetail";
import ReactDOM from "react-dom";
import localizationStrings from "../../../statics/localization";
import { TRACK_IDS } from "../../../analytics/trackIds";

const PlayerInfo = ({
  player,
  prevueCode,
  setSelectedCutvProgram,
  selectedChannel,
  userFrameConfig,
  userInfo,
  location,
  history,
  setRecordStatus,
  isFullscreen,
  programInfo,
  setPlayUrl,
  playUrl,
  hasLoggedIn
}) => {
  const programDetailEl = useRef(null);

  const createInfoEl = () => {
    programDetailEl.current = document.createElement("div");
    programDetailEl.current.classList.add("items-wrapper");
    programDetailEl.current.setAttribute("id", `player-program-info`);
    player.el().appendChild(programDetailEl.current);

    renderInfoBox();
  };

  const removeInfoEl = () => {
    ReactDOM.unmountComponentAtNode(
      document.getElementById(`player-program-info`)
    );
    programDetailEl.current.remove();
    programDetailEl.current = null;
  };

  const renderInfoBox = () => {
    ReactDOM.render(
      <ProgramDetail
        prevueCode={prevueCode}
        closeModal={() => removeInfoEl()}
        fromLive={true}
        setSelectedCutvProgram={setSelectedCutvProgram}
        selectedChannel={selectedChannel}
        userFrameConfig={userFrameConfig}
        userInfo={userInfo}
        location={location}
        hasHeight={true}
        isPlayer={true}
        history={history}
        setRecordStatus={setRecordStatus}
        programData={programInfo}
        setPlayUrl={setPlayUrl}
        playUrl={playUrl}
        hasLoggedIn={hasLoggedIn}
      />,
      document.getElementById(`player-program-info`)
    );
  };

  return (
    <button
      className="control-button"
      data-track-id={TRACK_IDS.PLAYER_INFO}
      title={localizationStrings.playerOptions.info}
      onClick={() => {
        programDetailEl.current ? removeInfoEl() : createInfoEl();
      }}
    >
      <PlayerInfoIcon />
    </button>
  );
};

export default PlayerInfo;
